module.exports = __webpack_public_path__ + "img/banner5.5bb1f533.png";